import React from 'react';
import { X } from 'lucide-react';
import { OutlineGenerator } from './OutlineGenerator';

interface OutlineDialogProps {
  isOpen: boolean;
  onClose: () => void;
  onOutlineGenerated: (outline: string) => void;
  existingTitle?: string;
  bookType?: string;
  targetWordCount?: number;
}

export function OutlineDialog({
  isOpen,
  onClose,
  onOutlineGenerated,
  existingTitle,
  bookType,
  targetWordCount,
}: OutlineDialogProps) {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-50 overflow-y-auto">
      <div className="flex min-h-screen items-center justify-center px-4 pt-4 pb-20 text-center sm:block sm:p-0">
        <div
          className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity"
          onClick={onClose}
        />
        <div className="inline-block align-bottom bg-white rounded-lg px-4 pt-5 pb-4 text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:align-middle sm:max-w-3xl sm:w-full sm:p-6">
          <div className="absolute top-0 right-0 pt-4 pr-4">
            <button
              type="button"
              className="bg-white rounded-md text-gray-400 hover:text-gray-500 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
              onClick={onClose}
            >
              <span className="sr-only">Close</span>
              <X className="h-6 w-6" />
            </button>
          </div>
          <div className="sm:flex sm:items-start">
            <div className="mt-3 text-center sm:mt-0 sm:text-left w-full">
              <h3 className="text-lg leading-6 font-medium text-gray-900">
                Generate Book Outline
              </h3>
              <div className="mt-4">
                <OutlineGenerator
                  onOutlineGenerated={onOutlineGenerated}
                  existingTitle={existingTitle}
                  bookType={bookType}
                  targetWordCount={targetWordCount}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
